import Content, { THEMES } from './Content';

export { THEMES };

export default Content;
